export default __webpack_public_path__ + "static/media/tarot.14cb400c.jpeg";